import React, { useEffect, useState } from "react";
import { Button, List, Result, Tag } from "antd";
import { FaChevronRight, FaEdit } from "react-icons/fa";
import {useHistory, useParams} from "react-router-dom";
import { useSelector } from "react-redux";
import { ticketsEventService } from "../../services/ticketsEvent.service";
import ContentBlocker from "../../components/contentBlocker/contentBlocker";

export const BoxTickets = () => {
  const history = useHistory();
  const params = useParams();
  const [events, setEvents] = useState([]);
  const [countEventsToApprove, setCountEventsToApprove] = useState(0);
  const roleName = useSelector((state) => state.userSettings.roleName);

  const data = [
    <Button
        onClick={() => history.push("/course-view/approve-event")}
        className={`${((params.courseId === 'approve-event')) && ('active')} `}
        type={"primary"}
        classNames={"ant-btn-primary-white"}
        icon={<FaChevronRight />}
        iconPosition={"end"}
    >
      Por autorizar <Tag color={"#ff2f24"}>{countEventsToApprove}</Tag>
    </Button>
  ];

  useEffect(() => {
    const init = async () => {
      const result = await ticketsEventService.getAvailableToSale();
      if (result.events) {
        setEvents(result.events);
        setCountEventsToApprove(result.countEventsToApprove);
      }
    };

    init();
  }, []);

  const handleOpenView = (url) => {
    window.open(url, "_blank");
  };
  return (
    <section className="box-tickets">
      <aside className={"box-tickets-aside"}>
        <Button
          type={"primary"}
          className={"ant-btn-primary-orange"}
          htmlType={'button'}
          onClick={() => history.push("/course-view/new-event")}
        >
          <FaEdit />
          Publicar un evento
        </Button>
        {
          (roleName === 'Recursos Humanos') && (
            <List
                  size="large"
                  header={false}
                footer={false}
                bordered
                dataSource={data}
                renderItem={(item) => <List.Item>{item}</List.Item>}
            />
          )
        }
      </aside>
      <div className={"box-tickets-body"}>
        {events.length === 0 ? (
          <Result
            status="info"
            title="No hay eventos publicados en este momento"
          />
        ) : (
            <ContentBlocker
              content={events}
              handleClick={handleOpenView}
              limitArray={7}
              typeContent={"billboard"}
              title={"¿Quieres ver más eventos?"}
            />
        )}
      </div>
    </section>
  );
};
